var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgMasInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22.6667H15.5833V19.8333H12.75V22.6667ZM14.1667 0C6.34667 0 0 6.34667 0 14.1667C0 21.9867 6.34667 28.3333 14.1667 28.3333C21.9867 28.3333 28.3333 21.9867 28.3333 14.1667C28.3333 6.34667 21.9867 0 14.1667 0ZM14.1667 25.5C7.91917 25.5 2.83333 20.4142 2.83333 14.1667C2.83333 7.91917 7.91917 2.83333 14.1667 2.83333C20.4142 2.83333 25.5 7.91917 25.5 14.1667C25.5 20.4142 20.4142 25.5 14.1667 25.5ZM14.1667 5.66667C11.0358 5.66667 8.5 8.2025 8.5 11.3333H11.3333C11.3333 9.775 12.6083 8.5 14.1667 8.5C15.725 8.5 17 9.775 17 11.3333C17 14.1667 12.75 13.8125 12.75 18.4167H15.5833C15.5833 15.2292 19.8333 14.875 19.8333 11.3333C19.8333 8.2025 17.2975 5.66667 14.1667 5.66667Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMasInfo);
export default __webpack_public_path__ + "static/media/ImgMasInfo.3ae8ad2339bbf968d57d6f0011c3dcce.svg";
export { ForwardRef as ReactComponent };